import baseKey from './_baseKey';

/**
 * 작업 티켓 유형
 */
export type ServiceType = 'item' | 'preset' | 'work-schedules';

const serviceDomainKey = (serviceSubDomains?: string[]) =>
  baseKey.domainKey('service', serviceSubDomains);

const serviceKey = {
  /**
   * @returns 서비스 항목 도메인 기본 쿼리키
   * @example ['serviceItem']
   */
  domain() {
    return serviceDomainKey();
  },
  /**
   * @returns 서비스 항목 전체 리스트 요청 쿼리키
   * @example ['service', 'item', 'list', 1}]
   */
  listById(id: number, serviceType: ServiceType) {
    return [...serviceDomainKey([serviceType]), 'list', id];
  },

  /**
   * @returns 서비스 항목 전체 리스트 요청 쿼리키
   * @example ['service', 'item', 'list'}]
   */
  list(serviceType: ServiceType) {
    return [...serviceDomainKey([serviceType]), 'list'];
  },
};

export default Object.freeze(serviceKey);
